function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKebabMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5,19.747C6.796,19.747 8.255,21.207 8.255,23.003C8.255,24.799 6.796,26.258 5,26.258C3.204,26.258 1.745,24.799 1.745,23.003C1.745,21.207 3.204,19.747 5,19.747ZM5,10.447C6.796,10.447 8.255,11.906 8.255,13.702C8.255,15.498 6.796,16.957 5,16.957C3.204,16.957 1.745,15.498 1.745,13.702C1.745,11.906 3.204,10.447 5,10.447ZM8.255,4.401C8.255,6.197 6.796,7.656 5,7.656C3.204,7.656 1.745,6.197 1.745,4.401C1.745,2.605 3.204,1.146 5,1.146C6.796,1.146 8.255,2.605 8.255,4.401Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKebabMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kebab-menu.531b87a6e9d6ffd81a9d9dc8ffc3bb4c.svg";